import { useMemo, useState } from "react";
import { useGetRemittanceSettingsQuery } from "../../../store/queries/remittanceSettings";

const useRemittanceSettings = () => {
  const { data: settingsData, isFetching, refetch } =
    useGetRemittanceSettingsQuery();

  const [showEditModal, setShowEditModal] = useState(false);

  const hasUpdatePermission = useMemo(() => {
    const permission = settingsData?.data?.permission?.find((p) =>
      Object.keys(p).includes("can_update")
    );
    return permission?.can_update ?? 0;
  }, [settingsData]);

  const tableData = useMemo(() => {
    const data = settingsData?.data?.data;
    if (!data) return [];
    return [data];
  }, [settingsData]);

  const handleEditAction = () => {
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const getRow = (field, data) => {
    return <p className="pro-mb-0">{data[field]}</p>;
  };

  return {
    settingsData,
    tableData,
    isFetching,
    showEditModal,
    hasUpdatePermission,
    handleEditAction,
    closeEditModal,
    getRow,
    refetch,
  };
};

export default useRemittanceSettings;
